<p>Позволяет отображать расширенную информацию при нажатии на строку</p>
<p> Необхходимо использовать директиву ngxAurExpandedRowDef внутри &lt;aur-mat-table&gt; для передачи template который будет отображать подробную информацию</p>
<p>Необходимо импортировать модуль BrowserAnimationsModule</p>
<pre>
  &lt;aur-mat-table ...&gt;
    &lt;ng-template ngxAurExpandedRowDef let-row="row"&gt;
      &lt;app-row-details [row]="row"&gt;&lt;/app-row-details&gt;
    &lt;/ng-template&gt;
  &lt;/aur-mat-table&gt;
</pre>
<p>Также можно настроить bodyRowCfg.highlightCfg и bodyRowCfg.hoverCfg для управления подсветкой и наведением строк и тп </p>
<p>Пример</p>
<pre>
  bodyRowCfg: &#123;
    highlightCfg: &#123;
      styleCfg: &#123;
        style: StyleBuilder.Row.builder()
          .background('blue').color('red')
          .border(b =&gt; b.allBorders('2px', StyleBuilder.BorderStyle.SOLID, 'green')),
      &#125;,
      cancelable: true
    &#125;,
    hoverCfg: &#123; pointer: true &#125;
  &#125;,
</pre>

<hr/>
<h3>Маркер-классы типов строк</h3>
<p>Каждый <code>&lt;tr&gt;</code> несёт стабильный класс:
  <code>aur-data-row</code>, <code>aur-expanded-row</code>, <code>aur-total-row</code>.
  Стилизуйте их своим (глобальным / <code>::ng-deep</code>) CSS. В этом примере detail-строка
  получает фон и сброс hover (см. expanding-row.component.scss):</p>
<pre>
  :host ::ng-deep tr.aur-expanded-row &#123; background: #fafafa; &#125;
  :host ::ng-deep tr.aur-expanded-row:hover &#123; background: #fafafa; &#125;
</pre>

<aur-mat-table
  [tableData]="tableData"
  [tableConfig]="tableConfig">
  <ng-template ngxAurExpandedRowDef let-row="row">
    <app-row-details [row]="row"></app-row-details>
  </ng-template>
</aur-mat-table>

<hr/>
<h3>Controlled (источник правды — контейнер, two-way)</h3>
<p>Раскрытая строка хранится в контейнере: <code>{{ expandedCustomer?.name ?? '—' }}</code></p>
<aur-mat-table
  [tableData]="controlledData"
  [tableConfig]="controlledConfig"
  [(expandedRow)]="expandedCustomer">
  <ng-template ngxAurExpandedRowDef let-row="row">
    <app-row-details [row]="row"></app-row-details>
  </ng-template>
</aur-mat-table>

<hr/>
<h3>Multiple (несколько раскрытых строк)</h3>
<p>Раскрыто строк: <code>{{ expandedCustomers.length }}</code></p>
<aur-mat-table
  [tableData]="multipleData"
  [tableConfig]="multipleConfig"
  [(expandedRows)]="expandedCustomers">
  <ng-template ngxAurExpandedRowDef let-row="row">
    <app-row-details [row]="row"></app-row-details>
  </ng-template>
</aur-mat-table>
